export default __webpack_public_path__ + "static/media/Credit-bro.c0886ea8.svg";